// Session management storage utilities
// Separated to avoid circular dependencies with useAuth

// Storage keys
export const SESSION_START_KEY = "jobteen_session_start";
export const LAST_ACTIVITY_KEY = "jobteen_last_activity";
export const REMEMBER_ME_KEY = "jobteen_remember_me";
export const SESSION_EXPIRED_KEY = "jobteen_session_expired";

// Session duration constants (in milliseconds)
export const SESSION_DURATIONS = {
  student: 24 * 60 * 60 * 1000, // 24 hours
  employer: 12 * 60 * 60 * 1000, // 12 hours
  remember_me: 7 * 24 * 60 * 60 * 1000, // 7 days
};

export const INACTIVITY_TIMEOUT = 45 * 60 * 1000; // 45 minutes
export const WARNING_BEFORE_TIMEOUT = 2 * 60 * 1000; // 2 minutes warning

// Utility function to set "Remember Me" preference
export const setRememberMe = (value: boolean): void => {
  if (value) {
    localStorage.setItem(REMEMBER_ME_KEY, "true");
  } else {
    localStorage.removeItem(REMEMBER_ME_KEY);
  }
};

// Utility function to get "Remember Me" preference
export const getRememberMe = (): boolean => {
  return localStorage.getItem(REMEMBER_ME_KEY) === "true";
};

// Utility function to initialize session on login
export const initializeSession = (): void => {
  localStorage.setItem(SESSION_START_KEY, Date.now().toString());
  localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());
};

// Utility function to clear session data on logout
export const clearSessionData = (): void => {
  localStorage.removeItem(SESSION_START_KEY);
  localStorage.removeItem(LAST_ACTIVITY_KEY);
  // Keep REMEMBER_ME_KEY as it's a user preference
};
